<template>
  <div id="app">
    <navBar></navBar>
    <router-view/>
    <footerCom></footerCom>
  </div>
</template>

<script>
import navBar from '@/components/navBar';
import footerCom from '@/components/footer';
export default {
  name: 'App',
  components:{navBar,footerCom},
  created(){
    // if (this._isMobile()) {
    //   const url ='https://mobile.zymls.com';
    //   window.location.href = url;
    // }
  },
  methods:{
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Poppins-Black';
  src: url('./assets/font/Poppins-Black.otf') format('truetype');
}
@font-face {
  font-family: 'Poppins-Bold';
  src: url('./assets/font/Poppins-Bold.otf') format('truetype');
}
@font-face {
  font-family: 'Poppins-ExtraBold';
  src: url('./assets/font/Poppins-ExtraBold.otf') format('truetype');
}
@font-face {
  font-family: 'Poppins-Light';
  src: url('./assets/font/Poppins-Light.otf') format('truetype');
}
@font-face {
  font-family: 'Poppins-Medium';
  src: url('./assets/font/Poppins-Medium.otf') format('truetype');
}
@font-face {
  font-family: 'Poppins-Regular';
  src: url('./assets/font/Poppins-Regular.otf') format('truetype');
}
@font-face {
  font-family: 'Source Han Sans CN-Bold';
  src: url('./assets/font/subset-SourceHanSansCN-Bold-Alphabetic.ttf') format('truetype');
}
@font-face {
  font-family: 'Source Han Sans CN-Heavy';
  src: url('./assets/font/subset-SourceHanSansCN-Heavy-Alphabetic.ttf') format('truetype');
}
@font-face {
  font-family: 'Source Han Sans CN-Light';
  src: url('./assets/font/subset-SourceHanSansCN-Light-Alphabetic.ttf') format('truetype');
}
@font-face {
  font-family: 'Source Han Sans CN-Medium';
  src: url('./assets/font/subset-SourceHanSansCN-Medium-Alphabetic.ttf') format('truetype');
}
@font-face {
  font-family: 'Source Han Sans CN-Normal';
  src: url('./assets/font/subset-SourceHanSansCN-Normal-Alphabetic.ttf') format('truetype');
}
@font-face {
  font-family: 'Source Han Sans CN-Regular';
  src: url('./assets/font/subset-SourceHanSansCN-Regular-Alphabetic.ttf') format('truetype');
}
*{
  margin: 0;
  padding: 0;
  list-style-type: none;
  box-sizing: border-box;
}
body{
  min-width: 1400px;
  font-family: Source Han Sans;
}
#app {
  font-family: Source Han Sans,'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue